/* src/app/views/display/components/display-section/display-template-collection-section/display-menu-section-inside-template-collection/display-menu-section-inside-template-collection.component.scss */
bs-section-header-button-container {
  display: flex;
}
.edit-dates-times-button {
  padding-bottom: 1.5rem;
}
.is-scheduled-info-icon {
  width: 1.5rem;
  height: 1.5rem;
  padding-bottom: 0.25rem;
}
/*# sourceMappingURL=display-menu-section-inside-template-collection.component.css.map */
